import { render } from "./HomeSectionsManageView.vue?vue&type=template&id=2742ecbc&scoped=true"
import script from "./HomeSectionsManageView.vue?vue&type=script&lang=js"
export * from "./HomeSectionsManageView.vue?vue&type=script&lang=js"

import "./HomeSectionsManageView.vue?vue&type=style&index=0&id=2742ecbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2742ecbc"]])

export default __exports__